/* eslint-disable node/prefer-global/process */
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery } from '@tanstack/vue-query'

export const carTimersQueryKey = {
  all: () => ['carTimers'] as const,
  byCarId: (carId: number) => ['carTimers', carId] as const,
}

export function useCarTimers(carId: Ref<number>) {
  const { $trpc } = useNuxtApp()

  const fetchCarTimers = async (id: number) => {
    try {
      const result = await $trpc.auctions.getCarTimers.query({ carId: id })

      if (!result.data.singleItem.item?.itemData.hotbidDuration) {
        throw new Error('No data')
      }

      return result.data.singleItem.item.itemData.hotbidDuration
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }
    }
  }

  return useQuery(
    computed(() => carTimersQueryKey.byCarId(carId.value)),
    () => fetchCarTimers(carId.value),
    {
      enabled: computed(() => Boolean(carId.value && process.client)),
    },
  )
}
